export const COMPANY_SUPPORTS = {
  TTL: 'ttl',
  SCB: 'scb',
  EIF: 'eif',
  ECG: 'ecg',
  GTJA: 'gtja',
  CMBI: 'cmbi',
  BASIC: 'basic',
  FUBON: 'fubon'
}